import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import moment from 'moment';

@Injectable()
export class LocalParserFormatter implements NgbDateParserFormatter {

    private DISPLAY_FORMAT = 'DD/MM/YYYY';
    private ISO_FORMAT = 'YYYY-MM-DDTHH:mm:ss.SSS';

    public parse(v: string): LocalDateStruct {   // from input -> internal model
        let m = moment(v, this.DISPLAY_FORMAT);
        if (!m.isValid()) { return null; }
        return this.fromMoment(m);
    }

    public format(d: LocalDateStruct): string {  // from internal model -> string
        if (d == null) { return null; }
        let m = this.toMoment(d);
        if (!m.isValid()) { return null; }
        return m.format(this.DISPLAY_FORMAT);
    }

    public toMoment(d: LocalDateStruct): moment.Moment {
        if (d == null) { return null; }

        let momentArray = [d.year, d.month - 1, d.day, 0, 0, 0, 0];

        if (d.hour) { momentArray[3] = d.hour; }
        if (d.minute) { momentArray[4] = d.minute; }
        if (d.second) { momentArray[5] = d.second; }
        if (d.millisecond) { momentArray[6] = d.millisecond; }

        let m = moment(momentArray);
        return m;
    }

    public fromMoment(m: moment.Moment): LocalDateStruct {
        if (!m.isValid()) { return null; }
        let date: LocalDateStruct = {
            year: m.year(),
            month: m.month() + 1,
            day: m.date(),
            hour: m.hour(),
            minute: m.minute(),
            second: m.second(),
            millisecond: m.millisecond()
        };
        return date;
    }

    public fromDate(d: Date): LocalDateStruct {
        let m = moment(d);
        if (!m.isValid()) { return null; }
        return this.fromMoment(m);
    }

    public toDate(d: LocalDateStruct): Date {
        if (d == null) { return null; }
        let m = this.toMoment(d);
        if (!m.isValid()) { return null; }
        return m.toDate();
    }

    public fromIsoString(v: string): LocalDateStruct {
        let m = moment(v, this.ISO_FORMAT);
        if (!m.isValid()) { return null; }
        return this.fromMoment(m);
    }

    public toIsoString(d: LocalDateStruct): string {
        if (d == null) { return null; }
        let dt = this.toDate(d);
        if (dt == null) { return null; }
        return moment(dt).format(this.ISO_FORMAT);
    }

}

export interface LocalDateStruct extends NgbDateStruct {
    hour?: number;
    minute?: number;
    second?: number;
    millisecond?: number;
}
